import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { t } from 'i18next'
import { useRecoilValue } from 'recoil'
import { Row, Col, Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Swal from 'sweetalert2'

import env from '../../../env/src_config'
import { headersState } from '../../../recoil/recoil'
import { axiosError } from '../../../helpers/response'
import { isNull } from '../../../izUtils'
import Spinner from '../../spinner/Spinner'

const CheckFacilityLocationRequests = ({ modaltoggle, facilityValue }) => {
    const navigate = useNavigate();

    const headers = useRecoilValue(headersState);
    const [locationRequest, setLocationRequest] = useState([])

    useEffect(() => {
        getData();
    }, []) // eslint-disable-line

    const getData = () => {
        axios.post(env.api + '/api/client/facility/location/request/list/' + facilityValue, {}, {headers}).then(response => {
            if (response?.data && response?.data?.data) setLocationRequest(response.data.data);
        }).catch(error => {
            axiosError(error, navigate);
        });
    }

    const handleRequest = (request, action) => {
        axios.post(env.api + '/api/client/facility/location/request/resolve/' + request.id + '/' + action, {}, {headers}).then(response => {
            if (!isNull(response.data.state) && response.data.state === 'success') {
                Swal.fire({
                    title: t('saved'),
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonColor: 'var(--theme-default)',
                    confirmButtonText: t('ok'),
                }).then(() => {
                    // Refresh page
                    navigate(0);
                })
            }
        }).catch(error => {
            axiosError(error, navigate);
        });
    }

    return (
        <>
            <ModalHeader toggle={modaltoggle}>
                {t('facilities.location.request.title')}
            </ModalHeader>
            <ModalBody>
                {isNull(locationRequest) ?
                    <Spinner />
                    :
                    <Row>
                        <Col sm="12">
                            {locationRequest.length > 0 ?
                                locationRequest.map((request, index) => (
                                    <div key={index} className='mb-3 p-3 border rounded'>
                                        <div><strong>{t('facilities.location.request.location')}:</strong> {request.location}</div>
                                        <div><strong>{t('facilities.location.request.google_location')}:</strong> {request.google_location}</div>
                                        <div><strong>{t('facilities.location.request.user')}:</strong> {request.user?.name}</div>
                                        <div className='w-100 d-flex mt-2'>
                                            <Button color="danger" className='btn-sm me-2' onClick={() => handleRequest(request, 'decline')}>{t('decline')}</Button>
                                            <Button color="success" className='btn-sm me-2' onClick={() => handleRequest(request, 'accept')}>{t('accept')}</Button>
                                        </div>
                                    </div>
                                ))
                                :
                                <div>{t('facilities.location.request.noRequests')}</div>
                            }
                        </Col>
                    </Row>
                }
            </ModalBody>
            <ModalFooter>
                <div className='w-100 d-flex justify-content-between'>
                    <Button color="secondary" className='me-2' onClick={modaltoggle}>{t('close')}</Button>
                </div>
            </ModalFooter>
        </>
    )
}

export default CheckFacilityLocationRequests